module.exports = __webpack_public_path__ + "static/Woodstock-Showmotiv-da3e3e04d3ea7435c144441d318ac2c6.png";